export default {"src":"https://fishbrain.com/_next/static/media/rhodeIsland.d0587c19.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};